import { RefObject } from 'react'
import { BrowseTabData } from '../../../types/peer-analyser'
import CategorySection from './CategorySection'
import { lightImpactVibrate, trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'

interface BrowseCategoriesContentProps {
  selectedTab: BrowseTabData
  onCategoryClick?: (categoryId: string) => void
  contentScrollRef?: RefObject<HTMLDivElement>
}

export default function BrowseCategoriesContent({
  selectedTab,
  onCategoryClick,
  contentScrollRef
}: BrowseCategoriesContentProps) {
  const handleCategoryClick = (categoryId: string) => {
    if (!categoryId) return

    lightImpactVibrate()

    // Track category selection
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: 'BrowseCategories',
        buttonLabel: categoryId,
        eventId: categoryId
      }
    })

    onCategoryClick?.(categoryId)
  }

  if (!selectedTab?.sections?.length) {
    return null
  }

  return (
    <div ref={contentScrollRef} className='flex-1 pb-10 overflow-y-auto'>
      {selectedTab?.sections?.map((section, idx) => {
        if (!section?.id) return null
        return (
          <div key={section.id} className='flex flex-col'>
            {idx !== 0 && <div className='h-4 bg-[#F0F4F7]' />}
            <CategorySection section={section} onCategoryClick={handleCategoryClick} />
          </div>
        )
      })}
    </div>
  )
}
